/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const SUBDIRECTIONS_BEGIN = 'SUBDIRECTIONS_BEGIN';
export const ADD_SUBDIRECTIONS = 'ADD_SUBDIRECTIONS';
export const SUBDIRECTIONS_FAILURE = 'SUBDIRECTIONS_FAILURE';

export function fetchSubdir() {
	return async dispatch => {
		dispatch(subdirsBegin());
		await ApiService.getSubdirections()
			.then(
				result => {
					let normalized = normalizeById(result.Data, 'idSubdirection');
					dispatch(addSubdirs(normalized));
					return normalized;
				},
				error => {
					dispatch(subdirsError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export const subdirsBegin = () => ({
	type: SUBDIRECTIONS_BEGIN,
});

export const addSubdirs = data => ({
	type: ADD_SUBDIRECTIONS,
	payload: { data }
})

export const subdirsError = () => ({
	type: SUBDIRECTIONS_FAILURE,
})

